function HeaderClaq() {
    return (
      <div className="header">
      </div>
    );
  }

  export default HeaderClaq;